import React, { Component } from "react";
import styles from "./controlGroups.module.scss";
import { withCompanyGroups } from "../../../shared/containers/containerCompanyGroups";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import DeleteButton from "../../DeleteButton/DeleteButton";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import { states } from "../../../reducers/queriesStates";

class ControlDeleteGroup extends Component {
  constructor(props) {
    super(props);

    this.state = { isOpenConfirm: false };
  }

  componentDidUpdate(prevProps) {
    const { selectedGroup, deleteGroupDataState, onSelectedGroup } = this.props;

    if (prevProps.selectedGroup !== selectedGroup) {
      this.setState({ isOpenConfirm: false });
    }

    if (prevProps.deleteGroupDataState === states.REQUEST && deleteGroupDataState === states.READY) {
      onSelectedGroup(null);
    }
  }

  onDeleteConfirm(e) {
    e.stopPropagation();
    const { onDeleteGroup, selectedGroup, onSelectedGroup } = this.props;
    onDeleteGroup({ groupId: selectedGroup.id });

    this.setState({ isOpenConfirm: false });
  }

  onNotDeleteConfirm(e) {
    e.stopPropagation();
    this.setState({ isOpenConfirm: false });
  }

  render() {
    const { selectedGroup } = this.props;
    const { isOpenConfirm } = this.state;

    return (
      <div className={styles.deleteGroupPanel}>
        <ModalConfirmWindow isOpen={isOpenConfirm}>
          <DeleteConfirm
            onConfirmHandle={this.onDeleteConfirm.bind(this)}
            onNotConfirmHandle={this.onNotDeleteConfirm.bind(this)}
            text={`Удалить группу "${selectedGroup.title}"?`}
          />
        </ModalConfirmWindow>

        <ButtonPrimary
          handleClick={(e) => {
            e.stopPropagation();
            this.setState({ isOpenConfirm: true });
          }}
          title={`Удалить группу "${selectedGroup.title}"`}
        />
      </div>
    );
  }
}

export default withCompanyGroups(ControlDeleteGroup);
